import { useTranslation } from "react-i18next";
import { FrontendUserInfo, OrganizationInfo } from "node-library/dist/portal";
import { Card, Divider } from "@mui/material";

interface Props {
	user: FrontendUserInfo;
    organization: OrganizationInfo;
	removeUser: (organization:OrganizationInfo, user: FrontendUserInfo) => void;
}


export default function OrganizationUserRow(props: Props) {
	const { t: translation } = useTranslation();

	const {
		user,
        organization,
		removeUser,
	} = props;

    const avatarPlaceholder: React.ReactNode = (
            <div className="organzation-user-avatar">
                <div
                    className="typography-body-01"
                    style={{ color: "black" }}
                >{`${user?.firstName.charAt(0)}${user?.lastName.charAt(0)}`}</div>
            </div>
        );

	const organizationRowItem: React.ReactNode = (
			<Card
                className="organization-user-list-view-row"
                sx={{ backgroundColor: "white" }}
            >
                <div className="organization-user-list-view-row-item">
                    <div className="organization-user-info">
                    {avatarPlaceholder}
                        <div className="organization-user-name-info-detail">
                            <div 
                                className="typography-body-02"
                                style={{ color: "black" }}
                            >
                                {`${user?.firstName} ${user?.lastName}`}
                            </div>
                            <div className="organization-user-info-detail">
                                <div className="typography-caption organization-user-email">{user?.userName}</div>
                                <Divider 
                                    orientation="vertical"
                                    flexItem
                                    sx={{ my: "2px" }}
                                ></Divider>
                                <div className="typography-caption organization-user-phone-number">{user?.phoneNumber}</div>
                            </div>
                        </div>
                    </div>
                    <div 
                        className="typography-body-01 organization-remove-user-button"
                        id={`remove-user-from-organization=${user.userName}`}
                        style={{ cursor: "pointer" }}
                        onClick={(e) => {
                            e.stopPropagation();
                            removeUser(organization, user);
                    }}>
                        {translation("Remove")}
                    </div>
                </div>
            </Card>
	);
	return organizationRowItem;
}
